module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-01"
  }, [_c('i', [_vm._v("Barbara Cohen first put the idea of a book about King David and his wives into my mind and generously suggested that I try it, and I thank her")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_c('i', [_vm._v("What happened when I started to write was, of course, very different from the original idea. The story in somewhat its present form began on a fifty-foot boat called the")]), _vm._v(" P.S., "), _c('i', [_vm._v("which is the model for the")]), _vm._v(" Portia, "), _c('i', [_vm._v("and my thanks go to Phil and Sylvia Duryee; their daughter, Cornelia; and her husband, Terry Moore, with whom I have spent happy times on the")]), _vm._v(" P.S.")]), _vm._v(" "), _c('p', {
    staticClass: "fm-03"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("L")]), _vm._v("’"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-617a3729","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 69
// module chunks = 0